// extracted by mini-css-extract-plugin
export default {"alert":"Error_alert__DMIZa"};